<template>
  <v-row class="ma-0 pa-0" v-if="isUsuarioLogado()">
    <v-app-bar id="default-app-bar" app absolute height="70" flat
               class="v-bar--underline" color="transparent"
               :clipped-left="$vuetify.rtl" :clipped-right="!$vuetify.rtl">
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"/>
      <default-drawer-toggle class="hidden-sm-and-down"/>
      <v-toolbar-title class="font-weight-light text-h5" v-text="meta.title"/>
      <v-spacer/>
      <!--      <span>Bem-vindo<b>{{ nomeUsuarioLogado }}</b></span>-->
      <!--      <default-search class="hidden-sm-and-down"/>-->
      Modo Escuro
      <v-switch v-model="$vuetify.theme.dark"
                class="ma-0 pa-0 ml-2" color="secondary" hide-details/>
      <default-go-home/>
      <default-notifications/>
      <default-account/>
    </v-app-bar>
  </v-row>
</template>

<script>

import {get, sync} from 'vuex-pathify'
import {StatusLoginEnum} from "../../enums/status-login.enum"
import {mapGetters} from "vuex";
import {MapGetters} from "../../store/modules/auth/map-getters.auth";

export default {
  name: 'DefaultBar',

  data: () => ({
    nomeUsuarioLogado: '',
  }),
  methods: {
    isUsuarioLogado() {
      return (this.meta.title !== 'Login') && ((this.status === StatusLoginEnum.LOGADO) || (localStorage.jwt && localStorage.jwt !== ''));
    },
    setNomeUsuarioLogado() {
      this.nomeUsuarioLogado = this.nome ? ', ' + this.nome.split(' ').slice(0, 1).join(' ') : '';
    }
  },
  beforeMount() {
    this.setNomeUsuarioLogado();
  },
  components: {
    DefaultAccount: () => import(
        /* webpackChunkName: "default-account" */
        './widgets/Account'
        ),
    DefaultDrawerToggle: () => import(
        /* webpackChunkName: "default-drawer-toggle" */
        './widgets/DrawerToggle'
        ),
    DefaultGoHome: () => import(
        /* webpackChunkName: "default-go-home" */
        './widgets/GoHome'
        ),
    DefaultNotifications: () => import(
        /* webpackChunkName: "default-notifications" */
        './widgets/Notifications'
        ),
    DefaultSearch: () => import(
        /* webpackChunkName: "default-search" */
        './widgets/Search'
        ),
  },
  computed: {
    ...mapGetters(MapGetters.NOME_MODULO, [MapGetters.NOME, MapGetters.STATUS]),
    ...sync('app', [
      'drawer',
      'mini',
    ]),
    meta: get('route/meta'),
    path: get('route/path'),
    name: get('route/name'),
  },

  watch: {
    color(val) {
      this.$vuetify.theme.themes[this.isDark ? 'dark' : 'light'].primary = val
    },
  },
}
</script>

<style>
.v-btn {
  height: 2.5rem !important;
  font-size: 15px !important;
  color: white;
}

.container--fluid {
  padding-top: 0 !important;
}

.v-card__title {
  padding-bottom: .1875rem !important;
  padding-left: .5rem !important;
}

.theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-weight: bold !important;
}
</style>
